export default ".user-dropdown[data-v-0934c872] { z-index: 11;\n}\n"